import { Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import getSystemInfo from '@/utils/getSystemInfo';
import {justifyContent} from '@/components/Device';

import './style.less';

interface IDefault {
  events?: any;
  data?: any
  activeType?: any
  justifyContent?: justifyContent
}

@Component
export default class Default extends tsx.Component<IDefault> {
  
  @Prop() public events?: any
  @Prop() public data?: any
  @Prop() public activeType?: any
  @Prop() public justifyContent?: justifyContent
  
  render() {
    const {events,activeType} = this.$props;
    const narrow = activeType ? 1 : 0.8
    let {height , width} = getSystemInfo().deviceSize
    height = height * narrow;
    width = width * narrow;
    let marginleft =  (getSystemInfo().availableSizes - width) / 2
    return (
      <div class={`default-container ${ !activeType && 'phone-container-left'}`} style={`height:${height + 60}px; width:${width}px;`}>
        <div class='screen' style={`height:${height}px; width:${width}px`}>
          <img onClick={() =>events.routerPushPackage(null)} class='icon' src={require('@/assets/svg/add.svg')} alt=""/>
        </div>
        <div class='bottom'>
          <img class='arc' src={require('@/assets/img/arc.png')} alt=""/>
          <div onClick={() =>events.routerPushPackage(null)} class='button'>
            购买云手机
          </div>
        </div>
      </div>
    )
  }
  
}